export default __webpack_public_path__ + "static/media/gl-13.7c9b7a07.png";